import { render, staticRenderFns } from "./bigPreview.vue?vue&type=template&id=8bbc83ba&scoped=true"
import script from "./bigPreview.vue?vue&type=script&lang=js"
export * from "./bigPreview.vue?vue&type=script&lang=js"
import style0 from "./bigPreview.vue?vue&type=style&index=0&id=8bbc83ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbc83ba",
  null
  
)

export default component.exports